import { ComumService } from './../../comum/comum.service';
import { Evento } from './../../comum/eventos/evento';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from './../usuario.service';
import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-usuarios',
  templateUrl: './listar-usuarios.component.html',
  styleUrls: ['./listar-usuarios.component.css']
})
export class ListarUsuariosComponent implements OnInit {

  usuarios: Usuario[];

  filtroPesquisaNomeUsuarioBind: string;

  paginacao: Paginacao;

  evento: Evento;

  public loading = false;
  public statusCode: number;

  constructor(private _usuarioService: UsuarioService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {

    this.paginacao = new Paginacao();

    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }

  }

  ngOnInit() {
    this.loading = true;
    this._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((usuarios: Usuario[]) => {
        this.usuarios = usuarios;
        this.loading = false;
      });
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeUsuarioBind = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  removerUsuario(usuario: Usuario): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o usu\u00e1rio?',
      accept: () => {
        this.loading = true;
        this._usuarioService.removerUsuarioHttp(usuario.idUsuario).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.removerUsuarioFromList(this.usuarios, usuario);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this._comumService.evento.deletar = true;
          this._comumService.evento.error = true;
          this.loading = false;
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        });
      },
      reject: () => {
      }
    });
  }

  removerUsuarioFromList(usuarios: Usuario[], usuario: Usuario): void {
    const index = this.obterIdUsuario(usuarios, usuario);
    usuarios.splice(index, 1);
  }

  obterIdUsuario(usuarios: Usuario[], usuario: Usuario): number {
    return usuarios.indexOf(usuario);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/usuario/listar-usuarios/listar-usuarios.component.ts